import type { AvailableSlotsResponse } from '@brighterly/lib-core-types/landing/interfaces'

import { useCsRoutes } from '@composables/routes/cs-route.hook'

interface AvailableSlotsApiPayload {
  kidId: string
  month: string
  extended?: boolean
}

export const useAvailableSlotsApi = async (payload: AvailableSlotsApiPayload): Promise<AvailableSlotsResponse | null> => {
  const { $axios } = useNuxtApp()

  const url = useCsRoutes('bookings.available-slots.upsell', {
    '[kid_id]': payload.kidId,
  })

  try {
    const { data } = await $axios.get(url!, {
      params: { month: payload.month, extended: payload.extended },
    })

    return {
      success: true,
      data: data,
      message: 'Success',
    }
  } catch (err) {
    console.error(err)
    return null
  }
}
